import React from 'react';
import classlist from 'utils/classlist';
import './style.scss';

export interface IPlatformSectionProps {
    header: string; // section的标题
    hasHeaderUnderline?: boolean; // 标题是否有下划线,默认为没有,标题下划线样式固定
    content: string; // section的内容
    imgSrc?: string; // 模块内的图片
    // 图片相对于content的位置，默认为left
    imgLocation?: 'left' | 'right';
    float?: boolean; // 部分文字是浮与图片上方的
    imgHeight?: number | string; // 部分图片的高度需要固定
    largeMargin?: boolean;
    pcImg?: boolean;
    className?: string;
}

const PlatformSection: React.FC<IPlatformSectionProps> = props => {
    const {
        header,
        hasHeaderUnderline = false,
        content,
        imgSrc,
        imgLocation = 'left',
        float,
        imgHeight,
        pcImg,
        className
    } = props;

    return (
        <section className={classlist('platform-section-root', className)}>
            <div
                className={classlist('platform-section-container', {
                    'container-reverse': imgLocation === 'right'
                })}>
                {imgSrc && (
                    <img
                        className={`section-img ${
                            float ? (imgLocation === 'left' ? 'float-content-left' : 'float-content-right') : ''
                        } ${pcImg ? 'section-pc-img' : ''}  section-img-${imgHeight} `}
                        src={imgSrc}
                        alt={header}
                    />
                )}
                <div className={`section-desc ${float ? 'flex-start-desc' : ''}`}>
                    <h1 className="platform-section-header">{header}</h1>
                    {hasHeaderUnderline && <div className="header-underline"></div>}
                    <p className="platform-section-content">{content}</p>
                </div>
            </div>
        </section>
    );
};

export default PlatformSection;
